export const FORM_SUBMISSION_ROUTES = [
  {
    path: '/job-form-submissions/create',
    name: 'CreateJobFormSubmission',
    component: () => import('./views/CreateJobFormSubmission.vue'),
  },
  {
    path: '/job-form-submissions/select-form',
    name: 'SelectJobForm',
    component: () => import('./views/SelectJobForm.vue'),
  },
  {
    path: '/job-form-submissions/:id/edit',
    name: 'EditJobFormSubmission',
    component: () => import('./views/EditJobFormSubmission.vue'),
  },
]

export const FIELD_FORM_SUBMISSION_ROUTES = [
  {
    path: 'job-form-submissions/create',
    name: 'FieldCreateJobFormSubmission',
    component: () => import('./views/CreateJobFormSubmission.vue'),
  },
  {
    path: 'job-form-submissions/select-form',
    name: 'FieldSelectJobForm',
    component: () => import('./views/SelectJobForm.vue'),
  },
  {
    path: 'job-form-submissions/:id/edit',
    name: 'FieldEditJobFormSubmission',
    component: () => import('./views/EditJobFormSubmission.vue'),
  },
]
